// Os dados do Pix vem do last_transaction do Pagar.me. Nem sempre o
// transaction_type chega preenchido, entao a presenca do QR Code tambem vale
// como identificacao — sem isso um pedido Pix era tratado como cartao e o QR
// nunca aparecia na tela.
export const dadosDoPix = detalhes => {
    if (!detalhes) return null;

    const tipo = String(detalhes.transaction_type || '').toLowerCase();
    const temQrCode = Boolean(detalhes.qr_code || detalhes.qr_code_url);

    if (tipo !== 'pix' && !temQrCode) return null;

    return {
        qr_code: detalhes.qr_code || null,
        qr_code_url: detalhes.qr_code_url || null,
    };
};
